'use-client';

import React from 'react';
import View from '../view';
import css from './banner.module.scss';
import { cn } from '@nextui-org/react';

type Props = {
  source: string;
  heading?: string;
  description?: string;
};

const VideoBanner = ({ source, heading, description }: Props) => {
  return (
    <View className={cn(css.container)}>
      <React.Suspense fallback={<p>Loading video...</p>}>
        <iframe
          title="Video from Vimeo"
          src={source}
          allow="autoplay; fullscreen"
          allowFullScreen
        ></iframe>
      </React.Suspense>
      <View className={cn(css.layer)}>
        {heading && (
          <h1 className="font-bold text-default-50 text-3xl sm:text-4xl md:text-5xl tracking-wide urw-din-medium text-center max-w-2xl">
            {heading}
          </h1>
        )}
        {description && (
          <p className="text-small text-default-200">{description}</p>
        )}
      </View>
    </View>
  );
};

export default VideoBanner;
